import React, { useState, useEffect } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  FlatList,
  Modal,
  StyleSheet,
  TextInput,
  Image,
  Picker,
} from "react-native";

const RepeatModal = ({
  isVisible,
  onClose,
  icons,
  onConfirm,
  repeatappointmentlimit,
  repeat_count
}) => {
  const [selectedOption, setSelectedOption] = useState("None");
  const [repeatFrequency, setRepeatFrequency] = useState("1");
  const [repeatOccurrences, setRepeatOccurrences] = useState(repeat_count);
  const [selectedDays, setSelectedDays] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  const options = ["None", "Daily", "Weekly", "Monthly"];
  const daysOfWeek = ["sun", "mon", "tue", "wed", "thur", "fri", "sat"];
  const frequencyOptions = ["", ...Array.from({ length: 30 }, (_, i) => (i + 1).toString())];

  const toggleDay = (day) => {
    setSelectedDays((prev) =>
      prev.includes(day)
        ? prev.filter((d) => d !== day)
        : [...prev, day]
    );
  };

  const validateOccurrences = (value) => {
    const numValue = parseInt(value, 10);

    if (value === "" || isNaN(numValue)) {
      setErrorMessage("Please enter a valid number");
      return false;
    }

   const limit = Number(repeatappointmentlimit);

if (
  repeatappointmentlimit !== null &&
  repeatappointmentlimit !== '' &&
  !isNaN(limit) &&
  numValue > limit
) {
  setErrorMessage(`Occurrences cannot exceed ${limit}`);
  return false;
}


    return true;
  };

  const validateFrequency = (value) => {
    if (value === "") {
      setErrorMessage("Please select a repeat frequency");
      return false;
    }
    return true;
  };

  const handleOccurrencesChange = (value) => {
    setRepeatOccurrences(value);
    if (validateOccurrences(value) && validateFrequency(repeatFrequency)) {
      setErrorMessage("");
    }
  };

  const handleFrequencyChange = (value) => {
    setRepeatFrequency(value);
    if (validateFrequency(value) && validateOccurrences(repeatOccurrences)) {
      setErrorMessage("");
    }
  };

  const handleConfirm = () => {
    if (selectedOption !== "None") {
      if (!validateFrequency(repeatFrequency)) return;
      if (!validateOccurrences(repeatOccurrences)) return;
      if (selectedOption === "Weekly" && selectedDays.length === 0) {
        setErrorMessage("Please select any one day of week.");
        return;
      }
    }
    const recurrenceData = {
      repeat: selectedOption,
      ...(selectedOption !== "None" && {
        frequency: repeatFrequency,
        occurrences: repeatOccurrences,
        days: selectedOption === "Weekly" ? selectedDays : undefined,
      }),
    };
    onConfirm(recurrenceData);
    onClose();
  };

  useEffect(() => {
    if (selectedOption !== "None") {
      if (repeatFrequency && repeatOccurrences) {
        if (validateFrequency(repeatFrequency) && validateOccurrences(repeatOccurrences)) {
          setErrorMessage("");
        }
      }
    } else {
      setErrorMessage("");
    }
  }, [repeatFrequency, repeatOccurrences, selectedOption]);

  useEffect(() => {
    setRepeatFrequency("1");
    setRepeatOccurrences(repeat_count);
    setSelectedDays([]);
    setErrorMessage("");
  }, [selectedOption]);

  return (
    <Modal
      visible={isVisible}
      animationType="slide"
      transparent={true}
      onRequestClose={onClose}
      testID="repeat-modal"
    >
      <View style={styles.overlay}>
        <View style={styles.modalContent}>
          <TouchableOpacity
            style={styles.closeButtonContainer}
            onPress={onClose}
            hitSlop={{ top: 20, bottom: 20, left: 20, right: 20 }}
            testID="close-button"
          >
            <Image
              source={{ uri: icons.modalclose }}
              style={styles.closeIcon}
              testID="close-icon"
            />
          </TouchableOpacity>

          <Text style={styles.title}>REPEAT</Text>

          <FlatList
            data={options}
            keyExtractor={(item) => item}
            renderItem={({ item }) => (
              <TouchableOpacity
                style={styles.option}
                onPress={() => setSelectedOption(item)}
                 testID={`option-${item.toLowerCase()}`}
              >
                <View
                  style={[
                    styles.radioCircle,
                    selectedOption === item && styles.selectedCircle,
                  ]}
                  testID={`radio-${item.toLowerCase()}`}/>
                <Text style={styles.optionText}>{item}</Text>
              </TouchableOpacity>
            )}
              testID="options-list"
          />

          {selectedOption !== "None" && (
            <>
              <View style={styles.inputRow}>
                <Text style={styles.label}>Every:</Text>
                <Picker
                  selectedValue={repeatFrequency}
                  onValueChange={handleFrequencyChange}
                  style={styles.picker}
                  testID="frequency-picker"
                >
                  <Picker.Item label="Select" value="" />
                  {frequencyOptions.slice(1).map((num) => (
                    <Picker.Item key={num} label={num} value={num} 
                     testID={`frequency-option-${num}`}
                    />
                  ))}
                </Picker>
                <Text style={styles.unit}>
                  {selectedOption === "Daily" && "day(s)"}
                  {selectedOption === "Weekly" && "week(s)"}
                  {selectedOption === "Monthly" && "month(s)"}
                </Text>
              </View>

              {selectedOption === "Weekly" && (
                <View>
                  <Text style={styles.label}>On:</Text>
                  <View style={styles.daySelector}>
                    {daysOfWeek.map((day) => (
                      <TouchableOpacity
                        key={day}
                        onPress={() => toggleDay(day)}
                        style={styles.dayButton}
                        testID={`day-button-${day}`}
                      >
                        <View
                          style={[
                            styles.checkbox,
                            selectedDays.includes(day) && styles.checkedBox,
                          ]}
                          testID={`checkbox-${day}`}

                        >
                          {selectedDays.includes(day) && (
                            <Text style={styles.checkMark}>✓</Text>
                          )}
                        </View>
                        <Text style={styles.dayText}>{day}</Text>
                      </TouchableOpacity>
                    ))}
                  </View>
                  {selectedDays.length === 0 && (
                    <Text style={styles.errorText} testID="day-error">Please select any one day of week.</Text>
                  )}
                </View>
              )}

              <View style={styles.inputRow}>
                <Text style={styles.label}>End:</Text>
                <Text style={styles.label}>After</Text>
                <TextInput
                  style={styles.input}
                  value={repeatOccurrences}
                  onChangeText={handleOccurrencesChange}
                  keyboardType="numeric"
                  testID="occurrences-input"
                />
                <Text style={styles.label}>Recurrences</Text>
              </View>

              {errorMessage ? (
                <Text style={styles.errorText}>{errorMessage}</Text>
              ) : null}
            </>
          )}

          <TouchableOpacity
            style={[
              styles.confirmButton,
              (errorMessage || (selectedOption !== "None" && (!repeatFrequency || !repeatOccurrences))) && styles.disabledButton,
            ]}
            onPress={handleConfirm}
            disabled={errorMessage || (selectedOption !== "None" && (!repeatFrequency || !repeatOccurrences))}
            testID="confirm-button"

          >
            <Text style={styles.confirmText}>Confirm</Text>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    justifyContent: "flex-end",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  modalContent: {
    backgroundColor: "white",
    padding: 24,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    position: "relative",
  },
  closeButtonContainer: {
    position: "absolute",
    top: 15,
    right: 15,
    padding: 10,
    zIndex: 10,
  },
  closeIcon: {
    width: 25,
    height: 25,
  },
  title: {
    fontSize: 20,
    fontWeight: "600",
    marginBottom: 5,
    fontFamily: "GT-Walsheim",
  },
  option: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 12,
  },
  radioCircle: {
    width: 24,
    height: 24,
    borderRadius: 12,
    borderWidth: 2,
    borderColor: "#000",
    marginRight: 12,
  },
  selectedCircle: {
    backgroundColor: "#000",
  },
  optionText: {
    fontSize: 16,
    fontFamily: "GT-Walsheim",
  },
  inputRow: {
    flexDirection: "row",
    alignItems: "center",
    marginVertical: 12,
    gap: 8,
  },
  label: {
    fontSize: 16,
    fontFamily: "GT-Walsheim",
  },
  input: {
    borderWidth: 1,
    borderColor: "#ccc",
    padding: 8,
    marginHorizontal: 8,
    width: 60,
    fontSize: 16,
    fontFamily: "GT-Walsheim",
  },
  picker: {
    width: 100,
    marginHorizontal: 8,
  },
  unit: {
    fontSize: 16,
    fontFamily: "GT-Walsheim",
    marginLeft: 8,
  },
  daySelector: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginVertical: 12,
    gap: 8,
  },
  dayButton: {
    flexDirection: "row",
    alignItems: "center",
    padding: 8,
  },
  checkbox: {
    width: 24,
    height: 24,
    borderWidth: 2,
    borderColor: "#000",
    marginRight: 8,
    justifyContent: "center",
    alignItems: "center",
  },
  checkedBox: {
    backgroundColor: "#000",
  },
  checkMark: {
    color: "white",
    fontSize: 16,
    fontFamily: "GT-Walsheim",
  },
  dayText: {
    fontSize: 14,
    fontFamily: "GT-Walsheim",
  },
  errorText: {
    color: "red",
    fontSize: 14,
    fontFamily: "GT-Walsheim",
    marginBottom: 12,
  },
  confirmButton: {
    backgroundColor: "#000",
    padding: 14,
    alignItems: "center",
    borderRadius: 8,
    marginTop: 16,
  },
  disabledButton: {
    backgroundColor: "#ccc",
  },
  confirmText: {
    color: "white",
    fontSize: 16,
    fontWeight: "600",
    fontFamily: "GT-Walsheim",
  },
});

export default RepeatModal;